export default "__VITE_ASSET__BlebeDWD__"